import React, { Component } from 'react';
import { Modal, message, Spin } from 'antd';
import HighSearchInput from '../../common/HighSearchInput';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';

class SetManager extends Component {
    state = {
        params: {},
        record: {},
        isEdit: true,
        visible: false,
        loading: false,
        userOptions: [],
    }

    show = (record) => {
        this.setState({
            record,
            params: {},
        }, () => {
            this.setState({
                visible: true,
            });
        });
    }

    hide = () => {
        this.setState({
            visible: false,
            userOptions: [],
        });
    }

    submit = () => {
        const {
            params: {
                userId,
            },
            record: {
                hospitalId,
            },
            userOptions,
        } = this.state;
        if (userId) {
            const isExist = userOptions.some(item => item.value == userId);
            if (!isExist) {
                message.warning('请选择正确的津石负责人');
                return;
            }
        } else {
            message.warning('请选择津石负责人');
            return;
        }
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.hospital.setHospitalJsChargeUser,
            data: {
                userId,
                hospitalId,
            },
            dataType: 'json',
            doneResult: res => {
                message.success(res.success);
                this.setState({
                    loading: false,
                }, () => {
                    this.hide();
                    this.props.loadData();
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            }
        };
        $.sendRequest(options);
    }

    handleHighSearchInputChange = (id, options, idName, optionsName) => {
        const { params } = this.state;
        params[idName] = id;
        this.setState({
            params,
            [optionsName]: options,
        });
    }

    render() {
        const { visible, loading, record } = this.state;
        const { jsChargeUserId, employeeCode, userCompellation } = record;

        const asterisk = <span style={{ color: 'red' }}>*</span>;
        const initValue = jsChargeUserId ? { key: String(jsChargeUserId), label: `${userCompellation}[${employeeCode}]`} : {};
        return (
            <Modal
                title='配置津石负责人'
                visible={visible}
                onCancel={this.hide}
                onOk={this.submit}
                className="create-modal EditPersonModal"
                wrapClassName="vertical-center-modal"
                width="450px"
                maskClosable={false}
            >
                <Spin spinning={loading}>
                    <div className="modal-content" style={{ padding: '0 20px' }}>
                        <ul className="modal-list">
                            <li className="modal-item">
                                <div className="item-left">{asterisk}津石负责人:</div>
                                <div className="item-right">
                                    {
                                        visible &&
                                        <HighSearchInput
                                            name='user'
                                            isEdit={true}
                                            keyword='keyword'
                                            style={{ width: 162 }}
                                            params={{ limit: 20 }}
                                            placeholder="输入姓名/工号检索"
                                            url={API_URL.investigation.queryUserByKey}
                                            initValue={initValue}
                                            config={{ id: 'userId', name: 'userCompellation', code: 'employeeCode' }}
                                            onChange={(id, options) => this.handleHighSearchInputChange(id, options, 'userId', 'userOptions')}
                                        />
                                    }
                                </div>
                            </li>
                        </ul>
                    </div>
                </Spin>
            </Modal>
        )
    }
}

export default SetManager;


// WEBPACK FOOTER //
// ./src/components/hospital/hospitalInfo/SetDirector.js